<!-- WIDOK DESKTOP -->

<ion-text color="dark" *ngIf="dateKeySeparator && !displayMobileView">
  <h6 class="ion-margin-vertical color-dark-gray">
    {{ dateKeySeparator }}
  </h6>
</ion-text>

<ion-row class="content color-black" *ngIf="!displayMobileView">
  <ion-col size="1">
    <img
      class="space-booking-view__image"
      [ngClass]="{
        'space-booking-view__image--plug': !row.bookingSpaces[0].space.image
      }"
      [src]="
        row.bookingSpaces[0].space.image
          ? row.bookingSpaces[0].space.image.filePath
          : spacePlug
      "
    />
  </ion-col>
  <ion-col size="1">
    {{ row.bookingSpaces[0].space.floor.building.name }}
  </ion-col>
  <ion-col size="1">
    {{ row.bookingSpaces[0].space.floor.name }}
  </ion-col>
  <ion-col size="1">
    {{ row.bookingSpaces[0].space.name }}
    <img
      *ngIf="row.bookingSpaces[0].space.subType"
      [src]="spaceService.searchSubtypeIcon(row.bookingSpaces[0].space.subType)"
      class="light"
    />
  </ion-col>
  <ion-col size="2">
    {{ row.startTime | dateSti }}
  </ion-col>
  <ion-col [attr.size]="showBarierrButtonsAndRegistrationNumber ? '2' : '4'">
    {{ row.endTime | dateSti }}
  </ion-col>
  <ion-col size="2" *ngIf="showBarierrButtonsAndRegistrationNumber">
    <ng-container *ngIf="row.userOwner">
      {{
        row.bookingSpaces[0].number
          ? row.bookingSpaces[0].number
          : row.userOwner.carPlate
      }}
    </ng-container>
  </ion-col>
  <ion-col size="2">
    <ng-container *ngIf="row.description">
      {{ row.description }} <strong>({{ "SPACE.GUEST" | translate }})</strong>
    </ng-container>
    <ng-container *ngIf="!row.description">
      {{ row.userOwner.firstName }} {{ row.userOwner.lastName }}
      <strong *ngIf="row.userOwner"
        >({{ companyServ.getCompanyName(row.userOwner.idCompany) }})</strong
      >
    </ng-container>
  </ion-col>

  <ion-col size="2">
    <app-status
      [color]="dictionaryServ.getDictionaryKeyColor(
        dictionaryServ.bookingStatusValues,
        row.status
      )"
      [name]="bookingServ.setStatusName(row.status)"
    ></app-status>
  </ion-col>

  <ion-col class="add-remove-col" size="1">
    <div
      *appHasRole="[editReservationRole]"
      class="options-button"
      size="small"
      (click)="presentPopover($event)"
    >
      <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
    </div>
  </ion-col>
</ion-row>

<!-- WIDOK MOBILNY -->

<ion-text color="dark" *ngIf="dateKeySeparator && displayMobileView">
  <h6
    class="ion-margin-vertical color-dark-gray space-booking-view__mobile-container"
  >
    {{ dateKeySeparator }}
  </h6>
</ion-text>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder space-booking-view__mobile-container"
>

  <ion-card-content class="booking-mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col class="space-between">
          <app-status
            [color]="
              dictionaryServ.getDictionaryKeyColor(
                dictionaryServ.bookingStatusValues,
                row.status
              )
            "
            [name]="bookingServ.setStatusName(row.status)"
          ></app-status>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>
  <ion-card-header class="space-booking-view__mobile-header">
    <div class="display-flex">
      <div>
        <ion-card-title>
          {{ spaceNameLabel }}
          {{ row.bookingSpaces[0].space.name }}
          <img
            class="space-booking-view__mobile-icon light"
            *ngIf="row.bookingSpaces[0].space.subType"
            [src]="
              spaceService.searchSubtypeIcon(row.bookingSpaces[0].space.subType)
            "
          />
        </ion-card-title>
        <ion-card-subtitle>
          <ion-icon src="../../../assets/icons/building-alt.svg"></ion-icon>
          {{ row.bookingSpaces[0].space.floor.building.name }}
          <ion-icon name="layers-outline" class="margin-left-8 light"></ion-icon>
          {{ row.bookingSpaces[0].space.floor.name }}
        </ion-card-subtitle>
      </div>
      <div
        *appHasRole="[editReservationRole]"
        class="options-button"
        size="small"
        (click)="presentPopover($event)"
      >
        <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
      </div>
    </div>
  </ion-card-header>

  <ion-card-content class="space-booking-view__mobile-content">
    <ion-grid class="no-padding-grid booking-mobile">
      <ng-container *ngIf="row.description && (row.owner=='guest')">
        <ion-row>
          <ion-col class="space-booking-view__mobile-barrier-header">
            <span></span>
            <div>{{ "SPACE.GUEST" | translate }}</div>
            <span></span>
          </ion-col>
        </ion-row>
        <ion-row class="margin-bottom-8">
            <ion-icon name="person-outline" class="margin-right-8"></ion-icon>
            {{ row.description }}
        </ion-row>
      </ng-container>
      
      <ion-row
        *ngIf="
          (row.qrcode || barriers.length) &&
          showBarierrButtonsAndRegistrationNumber
        "
      >
        <ion-col class="space-booking-view__mobile-barrier-header">
          <span></span>
          <div>{{ "SPACE.PARKING.OPEN_BARIERR" | translate }}</div>
          <span></span>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="showBarierrButtonsAndRegistrationNumber">
        <ion-col class="space-booking-view__mobile-buttons-container">
          <ng-container *ngFor="let item of barriers">
            <ion-button
              (click)="
                !showBarrierButtonForPastBookings ||
                (!item.key.includes('exit') &&
                  row.status == 'registredEntry') ||
                row.status == 'registredDeparture' ||
                row.status == 'canceled' ||
                avilableToOpenExitBarierr(item)
                  ? onShowPopover($event)
                  : openBarrier(item)
              "
              [ngClass]="{
                disabled:
                  !showBarrierButtonForPastBookings ||
                  (!item.key.includes('exit') &&
                    row.status == 'registredEntry') ||
                  row.status == 'registredDeparture' || 
                  row.status == 'canceled' ||
                  row.status == 'ended'
              }"
              [disabled]="
                onLoadingDisable ||
                row.status == 'canceled' ||
                row.status == 'ended'
              "
              class="space-booking-view__mobile-open-button"
              [fill]="
                !showBarrierButtonForPastBookings ||
                (!item.key.includes('exit') &&
                  row.status == 'registredEntry') ||
                row.status == 'registredDeparture' || 
                row.status == 'canceled' ||
                row.status == 'ended'
                  ? 'outline'
                  : 'solid'
              "
            >
              <ion-icon
                slot="start"
                [src]="
                  item.key.includes('exit')
                    ? '../../../assets/icons/parking-exit.svg'
                    : '../../../assets/icons/parking-enter.svg'
                "
                [color]="
                  showBarrierButtonForPastBookings ? 'primary' : 'secondary'
                "
                *ngIf="showBarrierButtonForPastBookings"
              ></ion-icon>
              <ion-text *ngIf="!p.renderSmallMobile">
                {{
                  onLoadingDisable ? barrierButtonText : exitButtonText(item)
                }}
              </ion-text>
              <ion-text *ngIf="!onLoadingDisable && p.renderSmallMobile">
                {{ exitButtonText(item) }}
              </ion-text>
              <ion-spinner *ngIf="onLoadingDisable" name="dots"></ion-spinner>
              <ion-icon
                slot="end"
                *ngIf="!showBarrierButtonForPastBookings"
                src="../../../../../assets/icons/info.svg"
                class="margin-left-8"
              ></ion-icon>
            </ion-button>
          </ng-container>
          <div
            [ngClass]="{
              'space-booking-view__button-container': !barriers.length
            }"
          >
            <ion-button
              *ngIf="row.qrcode && (row.status == 'new' || row.status == 'registredEntry')"
              Fill="outline"
              class="space-booking-view__mobile-generate-qr-button"
              [ngClass]="{
                'space-booking-view__mobile-generate-qr-button--disabled': !showBarrierButtonForPastBookings
              }"
              [disabled]="!showBarrierButtonForPastBookings"
              (click)="onQRCodePreview($event, row.qrcode.qrcodeValue)"
            >
              <ion-text
                class="space-booking-view__button-text"
                *ngIf="!barriers.length"
              >
                {{ "SPACE.SHOW_QR" | translate }}
              </ion-text>
              <ion-icon
                [ngClass]="{
                  'space-booking-view__mobile-open-button--disabled': showBarrierButtonForPastBookings
                }"
                slot="icon-only"
                color="secondary"
                src="../../../assets/icons/qr-code.svg"
              ></ion-icon>
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
      <ion-row
        *ngIf="
          customData != 'hideNameOnReservations' ||
          ((row.bookingSpaces[0].number || row.userOwner.carPlate) &&
            showBarierrButtonsAndRegistrationNumber)
        "
      >
        <ion-col class="space-booking-view__mobile-details-container">
          <div
            class="space-booking-view__mobile-details-inner-container"
            *ngIf="customData != 'hideNameOnReservations'"
          >
            <span>
              <ion-icon name="person-outline" class="margin-right-8"></ion-icon>
              <span class="margin-right-8">
                {{ row.userOwner.firstName }} {{ row.userOwner.lastName }}
              </span>
            </span>
            <span
              *ngIf="
                (row.bookingSpaces[0].number || row.userOwner.carPlate) &&
                showBarierrButtonsAndRegistrationNumber
              "
            >
              <ion-icon
                src="../../../assets/icons/car.svg"
                class="margin-right-8"
              ></ion-icon>
              {{
                row.bookingSpaces[0].number
                  ? row.bookingSpaces[0].number
                  : row.userOwner.carPlate
              }}
            </span>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="space-booking-view__mobile-dates-label">
          <span>
            {{ "SPACE.RESERVATION_START" | translate }}
          </span>
          <span>
            {{ "SPACE.RESERVATION_END" | translate }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          class="display-flex ion-align-items-center ion-justify-content-between"
        >
          <div
            class="space-booking-view__mobile-dot space-booking-view__mobile-dot--start"
          ></div>
          <div class="space-booking-view__mobile-separator"></div>
          <div
            class="space-booking-view__mobile-dot space-booking-view__mobile-dot--end"
          ></div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="space-booking-view__mobile-dates-container">
          <span>
            {{ row.startTime | dateSti }}
          </span>
          <span>
            {{ row.endTime | dateSti }}
          </span>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
